/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
	const btn = document.getElementById('test-upsells');

	btn?.addEventListener('click', function () {
		sessionStorage.removeItem('has-seen-tradein');
		alert("Cleared");
	});

	// Close upsells - needs to be on #cart-upsells as markup won't exist initially
	document.getElementById('cart-upsells')?.addEventListener('click', function (el) {
		if (el.target.dataset['closeDrawer']) {
			closeDrawer();
		}
	});

	// Delegate these as used on replaced markup
	document.addEventListener('click', function(event) {
		const trade = event.target.closest('[data-open-tradein]');
		const slideout = event.target.closest('[data-close-slideout]');
		const tradeModal = event.target.closest('.trade-in-modal');
		const techcheck = event.target.closest('[data-open-techcheck]');
		const conditions = event.target.closest('[data-open-conditions]');
		const battery = event.target.closest('[data-open-battery]');

		if(techcheck) {
			toggleDrawer(document.getElementById('techcheck'));
			event.preventDefault();
			return false;
		}

		if(conditions) {
			// Only intercept where the slide-out exists (cro45 PDP). On other
			// product templates the trigger falls through to the legacy
			// `:target` modal via its href.
			const conditionsDrawer = document.getElementById('conditions-slideout');
			if(conditionsDrawer) {
				toggleDrawer(conditionsDrawer);
				event.preventDefault();
				return false;
			}
		}

		if(battery) {
			const batteryDrawer = document.getElementById('battery-slideout');
			if(batteryDrawer) {
				toggleDrawer(batteryDrawer);
				event.preventDefault();
				return false;
			}
		}

		if(tradeModal) {
			document.getElementById('tradein-explained').showModal();
			event.preventDefault();
			return false;
		}

		if(trade) {
			toggleDrawer(document.getElementById('tradein'));
			event.preventDefault();
			return false;
		}

		if(slideout) {
			// If trade in was triggered by ATB, then toggle cart and remove the class to prevent another double transition
			let parent = event.target;

			while (parent) {

				// When closing slideout, if it was triggered by add to cart, sometimes we need to switch in cart-upsells
				if (parent.matches('.slideout')) {
					if (parent.matches('.slideout--trade-atb')) {
						parent.classList.toggle('slideout--trade-atb');
						toggleDrawer(document.getElementById('tradein'));
						openPostAddDrawer();
						return;
					}

					toggleDrawer(parent);
					return;
				}
				parent = parent.parentElement;
			}
		}
	});
});

function toggleDrawer(el, isAddWithTradeIn) {
    
    if(isAddWithTradeIn) {
      el.classList.toggle('slideout--trade-atb');
    }

    el.classList.toggle('slideout--open');
    document.querySelector('html').classList.toggle('slideout-open');
  }

  function closeDrawer() {
    document.querySelector('.slideout--open').classList.remove('slideout--open');
    document.querySelector('html').classList.remove('slideout-open');
  }

function openPostAddDrawer() {
	const drawer = document.getElementById('cart-upsells');

	if(!drawer) {
		return;
	}

	const content = drawer.querySelector('#cart-upsells-local .cart-upsells__content');

	// Section failed to render (Shopify returns null for it). Nothing to show, so send the customer to the cart.
	if(!content) {
		window.location.href = '/cart';
		return;
	}

	if(!drawer.querySelector('#cart-upsells-local .product-bundle-item')) {
		content.classList.add('cart-upsells__content--slim');
	}

	drawer.classList.add('slideout--open');
	document.querySelector('html').classList.add('slideout-open');
}

function refreshCartCount() {
	const countEl = document.querySelector('.header__cart-count--alt');

	if(!countEl) {
		return;
	}

	fetch('/cart.js', { headers: { Accept: 'application/json' } })
		.then(response => response.json())
		.then(cart => {
			countEl.dataset.count = cart.item_count;
		})
		.catch(() => {});
}


document.addEventListener('DOMContentLoaded',()=> {
	const mobileProductInfoWrapper =  document.querySelector('.mobile-product-info')
	const productInfoWrapper =  document.querySelector('.product-block-list__item.product-block-list__item--info.product-info-wrapper')
	if(mobileProductInfoWrapper && productInfoWrapper) {
	  if(window.innerWidth < 769) {
	  }
	}
  
	document.querySelectorAll('.block-swatch__item').forEach(element => {
	  element.addEventListener('click', function(){
		setTimeout(() => {
		  product_bundle_update();
		}, 1000);
	  });
	})
  
	document.querySelectorAll('.color-swatch').forEach(element => {
	  element.addEventListener('click', function(){
		setTimeout(() => {
		  product_bundle_update();
		}, 1000);
	  });
	})
  
	var add_buttons = document.querySelectorAll('.add-bundle-product-to-cart, .alt-add-button');
	if(add_buttons){
		add_buttons.forEach(button => {
			button.addEventListener('click', triggerAddToCart); 
		});
	}

	var alt_add_button = document.querySelector('.js-alternate-add-button');
	if(alt_add_button) {
		alt_add_button.addEventListener('click', triggerAddToCart); 
	}

	function triggerAddToCart(e) {		
		e.preventDefault();
		var actualAddToCartBtn = document.querySelector('.pdp-bundle-product-add-to-cart');
		if (actualAddToCartBtn) {
			actualAddToCartBtn.click();
		}
	}
  
	// document.querySelector('.product-bundle-inner .add-bundle-product-to-cart').addEventListener('click', function(e) {
	//   e.preventDefault();
	//   document.querySelector('.pdp-bundle-product-add-to-cart').click();
	// })
  
  })
  
  class ProductRecommendations extends HTMLElement {
	  constructor() {
		  super() 
	  this.init()
	  }
	  async init() {
		  try {
			  const text = await (await fetch(this.dataset.url)).text();
			  this.updateRecommendations(text)
		if(document.querySelector(".sticky-bottom-sheet")) {
		  this.checkVisibilityOnScroll()
		}
		this.addScrollEvent()
		  } catch (error) {
			  console.error(error)
		  }
	  }
	addScrollEvent () {
	  document.querySelectorAll('.bundle-wrapper').forEach((bundle, index) => {
		bundle.querySelectorAll('.rb-pdp-upsell-variant-item').forEach(input => {
			input.addEventListener('change', () => {
				// Function to scroll to the next .bundle-wrapper
				function scrollToNextBundle() {
					const currentBundle = input.closest('.bundle-wrapper');
					const allBundles = document.querySelectorAll('.bundle-wrapper');
					const currentIndex = Array.prototype.indexOf.call(allBundles, currentBundle);
					const nextIndex = Math.min(currentIndex + 1, allBundles.length - 1);
					const nextBundle = allBundles[nextIndex];
	
					if (nextBundle && nextBundle.classList.contains('bundle-wrapper')) {
						const headerHeight = 120;
						const bundleRect = nextBundle.getBoundingClientRect();
						const scrollPosition = bundleRect.top + window.scrollY - headerHeight;
	
						window.scrollTo({
							top: scrollPosition,
							behavior: 'smooth'
						});
					}
				}
	
				setTimeout(() => {
				  scrollToNextBundle();
				}, 500);
			});
		});
	  });
	}
	  updateRecommendations(text) {
	  const markup = new DOMParser().parseFromString(text, 'text/html');
		  const recommendations = markup.querySelector("product-recommendations");
		  recommendations && (this.innerHTML = recommendations.innerHTML)
	  }
	  checkVisibilityOnScroll() {
		  const productToCart = document.querySelector(".js-sticky-hide")
		  const	stickyCart = document.querySelector(".sticky-bottom-sheet");
		  if (productToCart) {
			  const onScroll = () => {
				  const rect = productToCart.getBoundingClientRect();
				  rect.top >= 0 && rect.bottom <= window.innerHeight ? stickyCart.classList.remove("slide-in") : window.scrollY > 0 && stickyCart.classList.add("slide-in")
			  };
			  window.addEventListener("scroll", onScroll), onScroll()
		  }
	  }
  }
  customElements.define("product-recommendations", ProductRecommendations)
  
  
  document.addEventListener("DOMContentLoaded", () => {
	  let addToCartPending = false;

	  document.querySelector(".product-template-wrapper .product-form .pdp-bundle-product-add-to-cart")?.addEventListener("click", function(e) {
		e.preventDefault();
		if(addToCartPending) {
			return false;
		}
		addToCart(e.currentTarget);
		return false;
	  });
  
	  function addToCart(button) {
	  	const mainProductIdSelect = document.querySelector('form[action$="/cart/add"] [name=id]');
		const proItems = document.querySelectorAll(".rb-pdp-upsell-variant-item:checked");
  
		  var line_items = Array();
		  if (proItems) {
			  for (var i = 0; i < proItems.length; i++) {
				  proItems[i].getAttribute("data-upsell-variant-id") != "" && (line_items[i] = {
					  id: parseInt(proItems[i].getAttribute("data-upsell-variant-id")),
					  quantity: 1,
					  parent_id: proItems[i].getAttribute("data-upsell-is-child") ? mainProductIdSelect.value : null
				  })
			  }
	  	  }

	  // If techcheck fee is set, get price of currently selected variant to work out fee to attach
	  const fee = mainProductIdSelect.dataset['techcheck'];
	  
	  if(fee == "true") {
		line_items.push({
			quantity: 1,
			id: getFeeVariantId( mainProductIdSelect.options[mainProductIdSelect.selectedIndex].dataset['price'] ),
			parent_id: mainProductIdSelect.value
		});		
	  }
  
	  line_items.push({
		quantity: 1,
		id: mainProductIdSelect.value
	  });
  
		addToCartPending = true;
		button.classList.add('is-loading');

		fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			body: JSON.stringify({
				items: line_items,
				sections: "cart-upsells"
			})
		}).then(response => {
			if(response.ok) {
				return response.json();
			}

			return response.json().then(errorData => {
				throw errorData;
			});
		}).then(data2 => {

			let hasTradeIn = data2.items.map(item => item.variant_id).indexOf(window.TRADEIN_GHOST_PRODUCT_VARIANT_ID) > -1;			

			if(data2.sections && data2.sections['cart-upsells']) {
				swapInSection(data2.sections['cart-upsells'], 'cart-upsells-local', 'cart-upsells-section');
			} else {
				// Don't show upsells left over from a previous add
				const local = document.getElementById('cart-upsells-local');
				if(local) {
					local.innerHTML = '';
				}
			}

			refreshCartCount();

			// Attach add to cart events for upsells which has just been swapped in
			document.getElementById('cart-upsells').querySelectorAll('.btn-item-to-cart[data-id]').forEach(el => {			
				el.addEventListener('click', (ev) => {
					let btn = ev.currentTarget;
					addVariantIdToCart(btn.dataset.id, () => {
						btn.classList.add('added');
					})
				})
			});
			
			if(!hasTradeIn && sessionStorage && !sessionStorage.getItem('has-seen-tradein')) {
				sessionStorage.setItem('has-seen-tradein', true);
				toggleDrawer(document.getElementById('tradein'), true);
				return;
			}
		
			// Short delay so it can animate
			setTimeout(function() {
				openPostAddDrawer();
			}, 100);  

			return;

		}).catch(error => {
			const dialog = document.getElementById('errorDialog');
			dialog.querySelector('[data-title]').innerText = 'Error';
			dialog.querySelector('[data-content]').innerText = error.description || error.message;
			dialog.showModal()
			console.error("There was a problem with the fetch operation:", error)
		}).finally(() => {
			addToCartPending = false;
			button.classList.remove('is-loading');
		});
	  }
  
	  function hs_update_cart(cart) {
		  window.HS_SLIDE_CART_REMOVED_FROM_CART = async function({
			  id
		  }) {
			  const variant = cart.items.find(item => item.id == id);
			  if (cart.items.length > 0) {
				  var matchItems = {};
				  cart.items.filter(item => {
					  item.properties.__parent_handle == variant.handle && (matchItems[`${item.key}`] = 0)
				  }), fetch("/cart/update.js", {
					  method: "POST",
					  headers: {
						  "Content-Type": "application/json",
						  Accept: "application/json"
					  },
					  body: JSON.stringify({
						  updates: matchItems
					  })
				  }).then(response => window.HS_SLIDE_CART_UPDATE())
			  }
		  }
	  }
	  window.HS_SLIDE_CART_UPDATED = function(cart) {
		  hs_update_cart(cart)
	  document.dispatchEvent(new CustomEvent('CUSTOM:HS_SLIDE_CART_UPDATED', {detail:{
		cart:cart
	  }}))
	  }, window.HS_SLIDE_CART_LOADED = function(cart) {
		  hs_update_cart(cart)
	  document.dispatchEvent(new CustomEvent('CUSTOM:HS_SLIDE_CART_LOADED', {detail:{
		cart:cart
	  }}))
  
	  }
  });
  
  function swapInSection(remoteMarkup, onPageTargetId, remoteId) {
	  let targetEl = document.getElementById(onPageTargetId);
  
	  if(!targetEl) {
		  return;
	  }
  
	  targetEl.innerHTML = new DOMParser().parseFromString(remoteMarkup, 'text/html').getElementById(remoteId).innerHTML;
  }
  
  function product_bundle_update () {
	const product_bundle = document.querySelector('.product-bundle-inner');
	const sticky_bottom_sheet = document.querySelector('.sticky-bottom-sheet');
  
	if(product_bundle == null) return;
  
	product_bundle.querySelector('.adt-product-desc').innerHTML = sticky_bottom_sheet.querySelector('.product-title-colour').innerHTML;
	product_bundle.querySelector('.adt-product-new-price').innerHTML = sticky_bottom_sheet.querySelector('.price.price--highlight').innerHTML;
	product_bundle.querySelector('.adt-product-old-price').innerHTML = sticky_bottom_sheet.querySelector('.price.price--compare').innerHTML;
	if(product_bundle.querySelector('.adt__klarna__price')) {
		product_bundle.querySelector('.adt__klarna__price').innerHTML = sticky_bottom_sheet.querySelector('.klarna__price').innerHTML;
	}	
  
  }
  
  // Tidal Rise - November 2022
  // Refactored reviews to replace JQuery with native javascript features.
  (function () {
	var reviews_wrapper = document.querySelector(
	  ".featured_reviews-section .reviews_wrapper"
	);
	if (!reviews_wrapper) {
	  return;
	}
	var dw =
	  (reviews_wrapper.closest(".shopify-section").clientWidth -
		reviews_wrapper.closest(".container").clientWidth) /
	  2;
	reviews_wrapper.style.width = reviews_wrapper.clientWidth + dw + "px";
	reviews_wrapper.style.marginRight = -dw + "px";
	var flick = new Flickity(reviews_wrapper, {
	  contain: true,
	  pageDots: false,
	  cellAlign: "left",
	});
  })();
  
  // Tidal Rise - November 2022
  // Refactored reviews to replace JQuery with native javascript features.
  (function () {
	var galleryWrapper = document.querySelector(
	  ".featured_gallery-section .gallery-wrapper"
	);
	if (galleryWrapper) {
	  var flick = new Flickity(galleryWrapper, {
		contain: true,
		pageDots: false,
		lazyLoad: 5,
		imagesLoaded: true,
		cellAlign: "center",
	  });
	}
  })();
  
  // Tidal Rise - November 2022
  // Refactored code to replace JQuery with native javascript features.
  (function () {
	var logosWrapper = document.querySelector(
	  ".featured_logo-section .section-wrapper .logo_panel .logos_wrapper"
	);
	if (logosWrapper) {
	  var flick = new Flickity(logosWrapper, {
		contain: true,
		prevNextButtons: false,
		pageDots: false,
		cellAlign: "left",
	  });
	}
  })();
  
  // Refulfil reworked this to consider that the modal can be opened from the TechCheck sticker too - which was causing the modal to persist and not shut if opened by a customer.
  document.addEventListener('DOMContentLoaded', () => {
	// Select both open modal buttons
	const openModalButtons = document.querySelectorAll(".product_whats_this, .badge.default-badge");
	const closeModalButton = document.querySelector("#open-modal.modal-window .modal-close");
	const modal = document.querySelector("#open-modal.modal-window");
  
	// Ensure buttons and modal exist
	if (openModalButtons.length === 0 || !modal) {
	  return;
	}
  
	// Add event listeners to each open modal button
	openModalButtons.forEach(button => {
	  button.addEventListener("click", event => {
		event.preventDefault();
		// Toggle modal active state
		modal.classList.toggle("active");
	  });
	});
  
	// Add event listener for closing the modal if the button exists
	if (closeModalButton) {
	  closeModalButton.addEventListener("click", event => {
		event.preventDefault();
		modal.classList.remove("active");
	  });
	}
  });
  
  function handleize(str) {
	str = str.toLowerCase();
	var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
	// For the old browsers
	for (var i = 0; i < toReplace.length; ++i) {
	  str = str.replace(toReplace[i], "");
	}
	str = str.replace(/\W+/g, "-");
	if (str.charAt(str.length - 1) == "-") {
	  str = str.replace(/-+\z/, "");
	}
	if (str.charAt(0) == "-") {
	  str = str.replace(/\A-+/, "");
	}
	return str;
  }
  
  // -------------------------------------------------------------------------
  // "Add to box" and "Buy button" redesign on PDP - On variant change
  // -------------------------------------------------------------------------
  
  (function () {
	document.addEventListener("variant:changed", function (event) {
	  var prices = document.querySelectorAll("[data-price]");
	  var comparePrices = document.querySelectorAll("[data-compare-price]");
  
	  
	  if (prices && prices.length) {
		prices.forEach((price) => {
		  price.textContent = Shopify.formatMoney(
			event.detail.variant.price,
			"£{{amount}}"
		  );
		});
	  }
	  if (comparePrices && comparePrices.length) {
		comparePrices.forEach((comparePrice) => {
		  comparePrice.textContent = Shopify.formatMoney(
			event.detail.variant.compare_at_price,
			"£{{amount}}"
		  );
		});
	  } 
	 
	  if(document.querySelector('.badge.variant-badge.active')) {
		document.querySelector('.badge.variant-badge.active').classList.remove('active')
	  }
	  const selectedBadge = document.querySelector(`.badge.variant-badge[data-vid="${event.detail.variant.id}"]`)
	  if(selectedBadge) {
		selectedBadge.classList.add('active')
	  }
  
	  var variantPrice = window.Shopify.formatMoney(event.detail.variant.price);
	  variantPrice = variantPrice.replace('.00', '');
	  var comparePrice = window.Shopify.formatMoney(event.detail.variant.compare_at_price);
	  comparePrice = comparePrice.replace('.00', '');
	  var disCountPrice = ((event.detail.variant.compare_at_price)-(event.detail.variant.price));
	  disCountPrice = window.Shopify.formatMoney(disCountPrice).replace('.00', '');
	  if(document.querySelector('#product-label--on-sale-price')) document.querySelector('#product-label--on-sale-price').innerHTML  = '<span>'+disCountPrice+'</span> off';
	  if(document.querySelector("[data-discount-badge]")) document.querySelector("[data-discount-badge]").innerHTML = disCountPrice;
	  if(document.querySelector('#price--highlight')) document.querySelector('#price--highlight').innerText  = variantPrice;
	  if(document.querySelector('#price--compare')) document.querySelector('#price--compare').innerText  = comparePrice;
	  const variant = event.detail.variant
	  const selectedCompareDealsCell = document.querySelector('.compare-deals__cell.selected')
	  if(selectedCompareDealsCell) {
		selectedCompareDealsCell.classList.remove('selected')
	  }
	  const newOption  = document.querySelector(`.compare-deals__cell[data-variant-id="${variant.id}"]`)
	  if(newOption) {
		newOption.classList.add('selected')
	  }
	});
  
	var addToCartSticky = document.querySelector(
	  ".product-form__add-button--sticky"
	);
	var addToCart = document.querySelector(".pdp-bundle-product-add-to-cart");
  
	if (!addToCart || !addToCartSticky) {
	  return;
	}
  
	addToCartSticky.addEventListener("click", function () {
	  addToCart.click();
  
	});
  })();
  
  var Shopify = Shopify || {};
  Shopify.money_format = "£{{amount}}";
  Shopify.formatMoney = function (cents, format) {
	if (typeof cents == "string") {
	  cents = cents.replace(".", "");
	}
	var value = "";
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = format || this.money_format;
  
	function defaultOption(opt, def) {
	  return typeof opt == "undefined" ? def : opt;
	}
  
	function formatWithDelimiters(number, precision, thousands, decimal) {
	  precision = defaultOption(precision, 2);
	  thousands = defaultOption(thousands, ",");
	  decimal = defaultOption(decimal, ".");
  
	  if (isNaN(number) || number == null) {
		return 0;
	  }
  
	  number = (number / 100.0).toFixed(precision);
  
	  var parts = number.split("."),
		dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
		cents = parts[1] ? decimal + parts[1] : "";
  
	  return dollars + cents;
	}
  
	switch (formatString.match(placeholderRegex)[1]) {
	  case "amount":
		value = formatWithDelimiters(cents, 2);
		break;
	  case "amount_no_decimals":
		value = formatWithDelimiters(cents, 0);
		break;
	  case "amount_with_comma_separator":
		value = formatWithDelimiters(cents, 2, ",", ".");
		break;
	  case "amount_no_decimals_with_comma_separator":
		value = formatWithDelimiters(cents, 0, ",", ".");
		break;
	}
  
	return formatString.replace(placeholderRegex, value);
  };
  
  (function () {
	document.addEventListener("DOMContentLoaded", function () {
	  handleResultCountChange();
	  document.addEventListener("theme:loading:end", handleResultCountChange);
	});
  
	function handleResultCountChange() {
	  var productListElement = document.querySelector(
		".product-list--collection"
	  );
	  if (!productListElement) return;
	  var productItems = productListElement.querySelectorAll(".product-item");
	  var resultCount = productItems.length;
  
	  var resultElementDesktop = document.querySelector(
		".collection__showing-count"
	  );
  
	  if (resultElementDesktop) {
		var resultText =
		  resultCount < 1
			? "No Results"
			: "Showing 1 - " + resultCount + " of " + resultCount;
		resultElementDesktop.innerHTML = resultText;
	  }
	  var resultElementMobile = document.querySelector(
		".collection__mobile-active-filters-results"
	  );
	  if (resultElementMobile) {
		var resultText = resultCount < 2 ? " Result" : " Results";
		resultElementMobile.textContent = resultCount + resultText;
	  }
	}
  })();
  
  // ------------------------------------------------------------------------
  // TechCheck Modal Condition Prices (Variant prices updates)
  // ------------------------------------------------------------------------
  (function () {
	document.addEventListener("DOMContentLoaded", function () {
	  var $conditionContainer = document.querySelector(".condition-my-condition");
	  if (!$conditionContainer) return;
	  let observer = new MutationObserver(setConditionPrice);
	  setConditionPrice();
  
	  function setConditionPrice() {
		var conditions = {
		  good: _getConditionPrice('[data-title="Good Condition"]'),
		  great: _getConditionPrice('[data-title="Great Condition"]'), 
		  excellent: _getConditionPrice('[data-title="Excellent Condition"]'),
		  pristine: _getConditionPrice('[data-title="Pristine"]'),
		};
  
		var $good = document.querySelector('[data-condition="Good"]');
		var $great = document.querySelector('[data-condition="Great"]');
		var $excelent = document.querySelector('[data-condition="Excellent"]');
		var $pristine = document.querySelector('[data-condition="Pristine"]');
		console.log('conditions.excellent',conditions.excellent)
		console.log('conditions.pristine',conditions.pristine)
		$good.innerHTML = conditions.good
		  ? "<span>" + conditions.good + "</span><span>Good</span>"
		  : "<span>Good</span>";
		$great.innerHTML = conditions.great
		  ? "<span>" + conditions.great + "</span><span>Great</span>"
		  : "<span>Great</span>";
		$excelent.innerHTML = conditions.excellent
		  ? "<span>" + conditions.excellent + "</span><span>Excellent</span>"
		  : "<span>Excellent</span>";
		$pristine.innerHTML = conditions.pristine
		  ? "<span>" + conditions.pristine + "</span><span>Pristine</span>"
		  : "<span>Pristine</span>";
	  }
  
	  function _getConditionPrice(selector) {
		var $el = $conditionContainer.querySelector(selector);
		if (!$el) return;
		var $priceEl = $el.querySelector(".block-swatch__item-text");
		observer.observe($priceEl, {
		  characterData: false,
		  attributes: false,
		  childList: true,
		  subtree: false,
		});
		return $priceEl.textContent;
	  }
	});
  })();
  
  
  // ----------------------------------------------------------------------------
  // Tidal Rise - After the cart has loaded, it was re rendered again by js (not sure why)
  // 				and for some reason that was destroying the instance of the upsell flickity slider.
  // 				To fix that we add a listener to check for cart rerenders and create a new instance.
  // ----------------------------------------------------------------------------
  
  (function () {
	document.addEventListener("DOMContentLoaded", function () {
	  var el = document.querySelector(".header__action-item--cart");
	  if (!el) return;
	  el.addEventListener("cart:rerendered", function () {
		var slider = document.querySelector(".cart-wrapper .product-list");
		if (!slider) return;
		new Flickity(slider, {
		  watchCSS: true,
		  pageDots: false,
		  prevNextButtons: true,
		  contain: true,
		  groupCells: true,
		  cellAlign: "left",
		  draggable: window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)")
			.matches,
		});
	  });
	});
  })();
  
  (function () {

	  /*
	   * Hide / show sticky add - possibly duplicated with <product-recs>, but does that always render?
	   */
	  window.addEventListener('DOMContentLoaded', function () {
		  var $bottomSheet = document.querySelector('.sticky-bottom-sheet');
		  if (!$bottomSheet) return;
		  window.addEventListener('scroll', handleScroll, { passive: true });

		  // For mobile - trigger initially (<768px)
		  if(window.matchMedia("(width <= 766px)").matches && document.body.scrollTop == 0) {
			$bottomSheet.classList.add('slide-in');
		  }
  
		  function handleScroll() {
  
			  var bodyPosition = document.body.scrollTop;
			  var documentPosition = document.documentElement.scrollTop;
			  var limit = 0; //500 in staging 0 in RBXD112
  
			  var showBottomSheet = bodyPosition > limit || documentPosition > limit;
			  if (showBottomSheet) {
				  $bottomSheet.classList.add('slide-in');
			  }
			  if (!showBottomSheet && $bottomSheet.classList.contains('slide-in')) {
				  $bottomSheet.classList.remove('slide-in');
			  }
  
		  }
	  });
  })();
  
  (function OpenWhatsInTheBox() {
	var toggleButton = document.querySelector(
	  '[aria-controls="whats_in_the_box"]'
	);
	var collapsibleContent = document.querySelector("#whats_in_the_box");
	if (!toggleButton || !collapsibleContent) return;
  
	toggleButton.setAttribute("aria-expanded", "true");
  
	if (collapsibleContent.hasAttribute("aria-hidden")) {
	  collapsibleContent.setAttribute("aria-hidden", "false");
	}
  
	var contentHeight = collapsibleContent.firstElementChild.offsetHeight;
	collapsibleContent.style.height = contentHeight + "px";
  })();
  
  // --------------------------------------------------------------
  // Smarty variable discounts
  // --------------------------------------------------------------
  window.Utilities = {
	getParam: function (param) {
	  const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	  });
	  return params[param];
	},
	getNumberFromPriceElement: function (element) {
	  return element.textContent.replace(/[^0-9]/g, "");
	},
	isLoading: function (start) {
	  var progressIndicator = document.querySelector(".js-discount-progress");
	  if (progressIndicator)
		progressIndicator.style.display = start ? "inline-block" : "none";
	},
  };
  window.Cookies = {
	set: function (cookieName, cookieValue, expirationDays) {
	  if (expirationDays !== 0) {
		const d = new Date();
		d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie =
		  cookieName + "=" + cookieValue + ";" + expires + ";path=/";
	  } else {
		document.cookie = cookieName + "=" + cookieValue + ";path=/";
	  }
	},
	get: function (cookieName) {
	  let name = cookieName + "=";
	  let ca = document.cookie.split(";");
	  for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == " ") {
		  c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
		  return c.substring(name.length, c.length);
		}
	  }
	  return "";
	},
  };
  

  window.CartService = {
	routes: {
	  cart: window.Shopify.routes.root + "cart.js",
	  updateCart: window.Shopify.routes.root + "cart/update.js",
	},
	get: function () {
	  return fetch(this.routes.cart)
		.then(function (response) {
		  return response.json();
		})
		.catch(function (error) {
		  console.log("Error while fetching cart data : ", error);
		});
	},
	update: function (attributes, discounts) {
	  return fetch(this.routes.updateCart, {
		method: "POST",
		headers: {
		  Accept: "application/json",
		  "Content-Type": "application/json",
		},
		credentials: "same-origin",
		body: JSON.stringify({ 
			attributes: attributes,
			discount: discounts
		}),
	  })
		.then(function (response) {
		  return response.json();
		})
		.catch(function (error) {
		  console.log("Error while fetching cart data : ", error);
		});
	},
  };  

  
  /*
   * SMARTY - auto discount
   */  
  (function smartyMain() {
	window.smartyUserID = window.Utilities.getParam("user_id");
	window.affiliate = window.Utilities.getParam("affiliate");

	if(window.smartyUserID) {
		window.CartService.update({ userID: window.smartyUserID }, 'SMARTY_ZZTXR362GC,SMARTY_ZZTXR362GB,SMARTY_ZZTXR362GA');   
	} else if(window.affiliate) {
		window.CartService.update({ userID: '_',}, 'LEBARA_RB45SM0VNHTB');
	}
  })();
  
  document.addEventListener("product:added", function (event) {
	window.scrollTo(0, 0);
  });
  
  (function InitializeCompareDealsTableScript() {
	const url = document.querySelector("[data-compare-deals-url]")?.dataset
	  .compareDealsUrl;
	if (!url) {
	  return;
	}
  
	let isScriptAppended = false;
  
	function appendJSFile(src) {
	  if (isScriptAppended) return;
  
	  const script = document.createElement("script");
	  script.src = src;
	  document.body.appendChild(script);
	  isScriptAppended = true;
  
	  ["mousemove", "scroll", "click"].forEach((event) => {
		document.removeEventListener(event, appendJSFile);
	  });
	}
  
	["mousemove", "scroll", "click"].forEach((event) => {
	  document.addEventListener(event, () => appendJSFile(url));
	});
  })();
  
  (function UpdateBestDealsVariants() {
	var bestDealsOptions = document.querySelectorAll(
	  "[data-best-deals] .block-swatch__item"
	);
	if (!bestDealsOptions.length) {
	  return;
	}
	var optionSelectors = document.querySelectorAll(
	  ".product-form__single-selector"
	);
	bestDealsOptions.forEach(function (opt) {
	  opt.addEventListener("click", updateVariantSelector);
	});
	document.addEventListener("variant:changed", handleVariantChange);
  
	function handleVariantChange(e) {
	  var variant = e.detail.variant;
  
	  bestDealsOptions.forEach(function (opt) {
		var variantMatches =
		  "dealId" in opt.dataset && opt.dataset.dealId == variant.id;
		if (variantMatches) {
		  opt.classList.add("selected");
		} else {
		  opt.classList.remove("selected");
		}
	  });
	}
  
	function updateVariantSelector(e) {
	  e.preventDefault();
	  var optionSelected = e.currentTarget.dataset.variantTitle;
  
	  if ("variantUrl" in e.currentTarget.dataset) {
		window.location.href = e.currentTarget.dataset.variantUrl;
		return;
	  }
  
	  optionSelectors.forEach(function (selector) {
		if (optionSelected.includes(selector.value)) {
		  selector.click();
		}
	  });
	}
  })();
  
  Date.prototype.addMinutes = function (m) {
	this.setTime(this.getTime() + m * 60 * 1000);
	return this;
  };
  
  Date.prototype.addHours = function (h) {
	this.setTime(this.getTime() + h * 60 * 60 * 1000);
	return this;
  };
  
  Date.prototype.addDays = function (d) {
	this.setTime(this.getTime() + d * 24 * 60 * 60 * 1000);
	return this;
  };
  
  function CountdownTimer() {
	this.days = [
	  "Sunday",
	  "Monday",
	  "Tuesday",
	  "Wednesday",
	  "Thursday",
	  "Friday",
	  "Saturday",
	  "Sunday",
	];
	this.months = [
	  "Jan",
	  "Feb",
	  "Mar",
	  "Apr",
	  "May",
	  "Jun",
	  "Jul",
	  "Aug",
	  "Sep",
	  "Oct",
	  "Nov",
	  "Dec",
	];
	this.dayInHours = 24;
	this.minuteInSeconds = 60;
  
	this.initialize = function (element) {
	  this.element = element;
  
	  this.deliveryDate = this.element.querySelector("[data-delivery-date]");
	  this.andText = this.element.querySelector("[data-sum-article]");
  
	  this.deliveryDays = parseInt(this.element.dataset.maxDays);
	  this.timeThreshold = parseInt(this.element.dataset.deliveryThreshold);
  
	  const currentDate = new Date();
	  this.now = new Date(
		currentDate.getTime() + currentDate.getTimezoneOffset() * 60000
	  );
  
	  this.targetDate = this.getTargetDate();
	  this.setDeliveryDate();
  
	  this.refs = {
		days: this.element.querySelector("[data-remaining-days]"),
		hours: this.element.querySelector("[data-remaining-hours]"),
		mins: this.element.querySelector("[data-remaining-minutes]"),
	  };
	};
  
	this.getTargetDate = function () {
	  var remainingMinutes = this.minuteInSeconds - this.now.getMinutes();
  
	  if (this.now.getHours() < this.timeThreshold) {
		this.remainingHours = this.timeThreshold - this.now.getHours() - 1;
		return new Date()
		  .addHours(this.remainingHours)
		  .addMinutes(remainingMinutes);
	  }
  
	  this.remainingHours =
		this.dayInHours - this.now.getHours() + this.timeThreshold - 1;
  
	  var remainingDays = 0;
	  if (this.now.getDay() === 0) {
		remainingDays = 1;
	  }
	  if (this.now.getDay() === 5) {
		remainingDays = 3;
	  }
	  if (this.now.getDay() === 6) {
		remainingDays = 1;
	  }
  
	  return new Date()
		.addHours(this.remainingHours)
		.addMinutes(remainingMinutes)
		.addDays(remainingDays);
	};
  
	this.getTimeRemaining = function (endtime) {
	  let total = Date.parse(endtime) - Date.parse(new Date());
	  let days = Math.floor(total / (1000 * 60 * 60 * 24));
	  let hours = Math.floor((total / (1000 * 60 * 60)) % 24);
	  let mins = Math.floor((total / 1000 / 60) % 60);
	  return {
		total,
		days,
		hours,
		mins,
	  };
	};
  
	this.updateTimer = function (timer) {
	  var dayText = timer.days > 1 ? " days " : " day ";
	  var hoursText = timer.hours > 1 ? " hours " : " hour ";
	  var minText = timer.mins > 1 ? " mins " : " min ";
	  this.refs.days.textContent = timer.days > 0 ? timer.days + dayText : "";
	  this.refs.hours.textContent =
		timer.hours === 0 ? "" : timer.hours + hoursText;
	  this.andText.style.display =
		(!timer.hours && !timer.days) || !timer.mins ? "none" : "inline";
	  this.refs.mins.textContent = timer.mins === 0 ? "" : timer.mins + minText;
	};
  
	this.startTimer = function () {
	  let timer = this.getTimeRemaining(this.targetDate);
	  this.updateTimer(timer);
	  setInterval(() => {
		let timer = this.getTimeRemaining(this.targetDate);
		this.updateTimer(timer);
	  }, 1000);
	};
  
	this.setDeliveryDate = function () {
	  var currentDate = new Date();
	  var newUTCDate = new Date(
		currentDate.getTime() + currentDate.getTimezoneOffset() * 60000
	  );
	  var offset = 0;
	  if (this._isThursday(newUTCDate)) {
		if (this.deliveryDays == 0 && this._isThresholdExceeded(newUTCDate)) {
		  offset += 1;
		} else if (
		  this.deliveryDays == 1 &&
		  this._isThresholdExceeded(newUTCDate)
		) {
		  offset += 3;
		} else {
		  offset += this._isThresholdExceeded(newUTCDate) ? 3 : 2;
		}
	  }
  
	  if (
		this._isFriday(newUTCDate) &&
		(this._isThresholdExceeded(newUTCDate) || this.deliveryDays > 0)
	  ) {
		offset += 3;
	  }
  
	  if (this._isSaturday(newUTCDate)) {
		offset += 2;
	  }
	  if (this._isSunday(newUTCDate)) {
		offset += 1;
	  }
	  if (
		!this._isSunday(newUTCDate) &&
		!this._isFriday(newUTCDate) &&
		!this._isSaturday(newUTCDate) &&
		!this._isThursday(newUTCDate) &&
		this._isThresholdExceeded(newUTCDate)
	  ) {
		offset += 1;
	  }
  
	  var remainingDays = this.deliveryDays + offset;
	  newUTCDate.addDays(remainingDays);
  
	  var currentMonth = this.months[newUTCDate.getMonth()];
	  var currentDay = this.days[newUTCDate.getDay()];
	  var currentDayNumber = newUTCDate.getDate();
	  this.deliveryDate.textContent = "".concat(
		currentDay,
		" ",
		currentDayNumber,
		"th ",
		currentMonth,
		"?"
	  );
	};
  
	this._isThresholdExceeded = function (date) {
	  return date.getHours() >= this.timeThreshold;
	};
  
	this._isSunday = function (date) {
	  return date.getDay() === 0;
	};
	this._isFriday = function (date) {
	  return date.getDay() === 5;
	};
	this._isThursday = function (date) {
	  return date.getDay() === 4;
	};
	this._isSaturday = function (date) {
	  return date.getDay() === 6;
	};
  }
  
  (function () {
	var shippingMessage = document.querySelector(".shipping-message");
	if (!shippingMessage) {
	  return;
	}
	var timer = new CountdownTimer();
	timer.initialize(shippingMessage);
	timer.startTimer();
  })();
  
  (function () {
	var buttons = document.querySelectorAll('[data-action="open-klarna-modal"]');
	if (!buttons) {
	  return;
	}
	buttons.forEach(element => {
	  console.log(element)
	  element.addEventListener("click", function (e) {
		e.preventDefault();
		var klarna = document.getElementsByTagName("klarna-placement")[0];
		if (klarna) {
		  try {
			klarna.shadowRoot.querySelector(".link").click();
		  } catch (error) {
			setTimeout(function () {
			  klarna.firstElementChild.shadowRoot.querySelector(".link").click();
			}, 500);
		  }
		}
	  });
	});
   
  })();
  
  (function () {
	var closeBtn = document.querySelectorAll(".continue-selling__close");
	if (!closeBtn || !closeBtn.length) {
	  return;
	}
  
	closeBtn.forEach(function (btn) {
	  btn.addEventListener("click", handleClose);
	});
  
	function handleClose(e) {
	  var btn = e.target;
	  var wrapper = btn.closest(".continue-selling__tooltip");
	  if (!wrapper) {
		return;
	  }
	  wrapper.classList.add("continue-selling__tooltip--hide");
	}
  
	document.addEventListener("variant:changed", function (event) {
	  var variant = event.detail.variant;
  
	  var productJsonElement = document.querySelector("[data-product-json]");
	  if (productJsonElement) {
		var jsonData = JSON.parse(productJsonElement.innerHTML);
		var variantsInventories = jsonData["inventories"] || {};
  
		var variantInventoryManagement =
		  variantsInventories[variant.id]["inventory_management"];
		var variantInventoryPolicy =
		  variantsInventories[variant.id]["inventory_policy"];
		var variantInventoryQuantity =
		  variantsInventories[variant.id]["inventory_quantity"];
		if (
		  variantInventoryManagement &&
		  variantInventoryPolicy == "continue" &&
		  variantInventoryQuantity <= 0
		) {
		  toggleTooltip(true);
		  changeShippingMessage(true);
		} else {
		  toggleTooltip(false);
		  changeShippingMessage(false);
		}
	  }
	});
  
	function changeShippingMessage(continueSelling){
	  const shippingMessage = document.querySelector(".stop-selling__delivery-message");
	  const shippingMessageContinue = document.querySelector(".continue-selling__delivery-message");
   
	  if(!shippingMessage && !shippingMessageContinue){
		return;
	  }
	  if (continueSelling) {
		shippingMessage.classList.add("delivery-message--hide");
		shippingMessageContinue.classList.remove("delivery-message--hide");
	} else {
		shippingMessage.classList.remove("delivery-message--hide");
		shippingMessageContinue.classList.add("delivery-message--hide");
	}
	}
  
	function toggleTooltip(op) {
	  closeBtn.forEach(function (btn) {
		var wrapper = btn.closest(".continue-selling__tooltip");
		if (!wrapper) {
		  return;
		}
		wrapper.classList.toggle("continue-selling__tooltip--hide", !op);
	  });
	}
  })();
  
  // RBXD86
  (function () {
	const sectionWrapper = document.getElementById(
	  "shopify-section-product-template"
	);
	if(!sectionWrapper) return;
	const section = sectionWrapper.firstElementChild;
	const jsonData = document.querySelector("[data-product-json]")?.textContent;
	if (!jsonData || !section) {
	  return;
	}
	const product = JSON.parse(jsonData)?.product;
  
	if (!product) {
	  return;
	}
  
	const inputs = section.querySelectorAll(".product-form input");
  
	section.addEventListener(
	  "variant:changed",
	  ({ detail: { variant, previousVariant } }) => {
		if (variant.option1 === previousVariant.option1 || variant.available) {
		  return;
		}
		const conditions = product.variants
		  .filter((v) => v.option1 === variant.option1 && v.available)
		  .map((v) => v.option2);
		if (!conditions) {
		  return;
		}
  
		const input = [...inputs].find((input) => input.value === conditions[0]);
		if (!input) {
		  return;
		}
		input.click();
	  }
	);
  })();
  
  (function () {
	const productTemplate = document.querySelector(".template-product");
	if (!productTemplate) {
	  // Tidal Rise - Added validation. Some products don't have the klarna-placement element
	  return;
	}
	waitForElm("klarna-placement").then((el) => {
	  el.parentElement.removeAttribute("style");
	});
  
	function waitForElm(selector) {
	  return new Promise((resolve) => {
		if (document.getElementsByTagName(selector)[0]) {
		  return resolve(document.getElementsByTagName(selector)[0]);
		}
  
		const observer = new MutationObserver((mutations) => {
		  if (document.getElementsByTagName(selector)[0]) {
			observer.disconnect();
			resolve(document.getElementsByTagName(selector)[0]);
		  }
		});
  
		observer.observe(document.body, {
		  childList: true,
		  subtree: true,
		});
	  });
	}
  })();
  
  document.addEventListener('variant:changed', function(event) {
	var variant = event.detail.variant; // Gives you access to the whole variant details
	const klarnaMD = document.querySelector('.klarna-terms .hidden-lap-and-up');
	const klarnaWidgetData = document.querySelector('.klarna__monthly-price .klarna__price');
	const installMent = parseInt(klarnaWidgetData.getAttribute('data-instalments'));
	const thresholdInstallment = parseInt(klarnaWidgetData.getAttribute('data-belowthreshold-installment'));
	const thresholdPrice = parseInt(klarnaWidgetData.getAttribute('data-thresholdprice'));
	if(!klarnaMD) return;
	if(variant.price > thresholdPrice ){
	  const klarnaPrice = variant.price / installMent
	  const priceFormatted = Currency.formatMoney(klarnaPrice, window.theme.moneyFormat) + '/mo';
	  document.querySelector('.klarna__monthly-price').innerHTML = 'Pay Monthly from <span class="klarna__price" data-klarna-price="" data-instalments="'+installMent+'" data-belowthreshold-installment="'+thresholdInstallment+'" data-thresholdprice="'+thresholdPrice+'">'+priceFormatted+'</span>';
	  klarnaMD.innerHTML = 'Pay over '+installMent+' months - ';
	}else{
	  const klarnaPrice = variant.price / thresholdInstallment
	  const priceFormatted = Currency.formatMoney(klarnaPrice, window.theme.moneyFormat) + '/mo';
	  document.querySelector('.klarna__monthly-price').innerHTML = 'Pay in '+thresholdInstallment+' installments of <span class="klarna__price" data-klarna-price="" data-instalments="'+installMent+'" data-belowthreshold-installment="'+thresholdInstallment+'" data-thresholdprice="'+thresholdPrice+'">'+priceFormatted+'</span>';
	  klarnaMD.innerHTML = 'Pay over '+thresholdInstallment+' months - ';
	}
  });
  
  
  function waitForElement(selector) {
		  return new Promise(resolve => {
			  if (document.querySelector(selector)) {
				  return resolve(document.querySelector(selector));
			  }
	  
			  const observer = new MutationObserver(mutations => {
				  if (document.querySelector(selector)) {
					  observer.disconnect();
					  resolve(document.querySelector(selector));
				  }
			  });
	  
			  observer.observe(document.body, {
				  childList: true,
				  subtree: true
			  });
		  });
	  }
  
	  (async function(){
	  const stickyBar = ".sticky-bottom-sheet";
	  if (!document.querySelector(stickyBar)) {
		return;
	  }
	  const ELEMENT = '#ba-cookie-dismiss';
	  const cookieBar = await waitForElement(ELEMENT);
		
	  if (!cookieBar.parentElement.parentElement.checkVisibility()) {
		return;
	  }
		
	  document.querySelector(stickyBar).classList.add('on-top-cookie-bar');
		
			  cookieBar?.addEventListener('click',function(){	
				document.querySelectorAll(ELEMENT).forEach(el=>{
				  el.parentElement.parentElement.remove();
				});
				  document.querySelector(stickyBar).classList.remove('on-top-cookie-bar');
			  });
		
	  })();
  
  
  
  var findTimer;
  
  findTimer = setInterval(function() {
	console.log("-----------------findtimer---------------", document.querySelectorAll(".mobile-product-info [data-best-deals] .block-swatch__item"));
	if(document.querySelectorAll(".mobile-product-info [data-best-deals] .block-swatch__item")) {
	  clearInterval(findTimer);
	  var mobileBestDealsOptions = document.querySelectorAll(".mobile-product-info [data-best-deals] .block-swatch__item");
	  var mobileOptionSelectors = document.querySelectorAll(".mobile-product-info .product-form__single-selector");
	  cnt = 0;
	  mobileBestDealsOptions.forEach(function (opt) {
		console.log("data-best-deals" + cnt, opt);
		opt.addEventListener("click", function(e) {
		  e.preventDefault();
		  var optionSelected = e.currentTarget.dataset.variantTitle;
		  console.log("updateVariantSelector", optionSelected);
	  
		  if ("variantUrl" in e.currentTarget.dataset) {
			window.location.href = e.currentTarget.dataset.variantUrl;
			return;
		  }
	  
		  mobileOptionSelectors.forEach(function(selector) {
			if (optionSelected.includes(selector.value)) {
			  selector.click();
			}
		  });
		});
	  });
	}
  }, 1000);
  
  
  // begin select condition variant selector
  
  
  document.addEventListener("DOMContentLoaded", function() {
  
	var conditionItems = document.querySelectorAll(".product-form__option .condition-my-condition input");
	var conditionModal = document.querySelector("#conditions-slideout");
	var conditionModalTabs = document.querySelectorAll("#conditions-slideout .techcheck-tabs input");

	conditionItems.forEach((item, index) => {

	  if(conditionModalTabs[index] && item.checked == true) {
		conditionModalTabs[index].checked = true;
	  }

	  item.addEventListener("change", function() {
		if(conditionModalTabs[index]) {
		  conditionModalTabs[index].checked = true;
		}
	  });
	});
  });
  
  
  // Function to filter products based on the range value on SMARTY page
  let priceFilterTimmer = undefined
  var slider = document.getElementById('price-slider');
  var lowerValue = document.getElementById('price-lower');
  var upperValue = document.getElementById('price-upper');
  var currencySymbol = document.querySelector("body").getAttribute('currency_Symbol');
  if(slider) {
	noUiSlider.create(slider, {
	  start: [0, 1000],
	  connect: true,
	  range: {
		  'min': 0,
		  'max': 1000
	  },
	  format: {
		  to: function (value) {
			  return value.toFixed(2);
		  },
		  from: function (value) {
			  return Number(value);
		  }
	  }
	});
	
	slider.noUiSlider.on('update', function (values, handle) {
	  if (handle === 0) {
		  lowerValue.innerHTML = currencySymbol+values[0];
	  } else {
		  upperValue.innerHTML = currencySymbol+values[1];
	  }
	  if(priceFilterTimmer != undefined) {
		clearTimeout(priceFilterTimmer)
	  }
	  priceFilterTimmer = setTimeout(()=> {
		handlePriceFilter(values)
	  },800)
	});
	
	// Initial filter on page load
	slider.noUiSlider.on('update');
  }
  
  
  
  document.querySelectorAll('.nav-dropdown').forEach( element => {
	element.addEventListener('mouseover', ()=> {
	  element.classList.add('active')
	  document.querySelector(`.nav-bar__link[data-target="${element.dataset.target}"]`)?.classList.add('active')
	})
	element.addEventListener('mouseout', ()=> {
	  element.classList.remove('active')
	  document.querySelector(`.nav-bar__link[data-target="${element.dataset.target}"]`)?.classList.remove('active')
	})
  })
  
  
  document.querySelectorAll('.nav-dropdown__link').forEach(( element)=> {
	element.addEventListener('mouseover', () => {
	  const nextSibling = element.nextSibling
	  if(nextSibling) {
		nextSibling.setAttribute('aria-expanded', true)
	  }
	})
	element.addEventListener('mouseover', () => {
	  const nextSibling = element.nextSibling
	  if(nextSibling) {
		setTimeout( ()=>{
		  nextSibling.setAttribute('aria-expanded', false)
		},100)
	  }
	})
  })
  
  
  
  // Change upsell block indexes for pdp
  document.addEventListener('DOMContentLoaded',()=> {
	document.querySelectorAll('.product_count-badge').forEach( (e,i) => {
	  e.textContent = i + 1
	})
  })
  
  // MTR Samsung Promotion, change made 2 April 2025
  // Redirects customers from Samsung Galaxy S24 Ultra 256GB to 512GB version
  // Only redirects when coming from outside the product pages to allow variant navigation once on the product
  // COMMENTED OUT AS PROMOTION HAS ENDED
  /*document.addEventListener('DOMContentLoaded', function() {
	const productHandle = document.querySelector('.rb-main-product-handle')?.getAttribute('data-product-handle');
	if (productHandle && productHandle.includes('samsung-galaxy-s24-ultra-256gb')) {
	  // Check if the referrer is not from a product page
	  const referrer = document.referrer;
	  const isFromProductPage = referrer.includes('/products/');
	  
	  // Only redirect if not coming from another product page
	  if (!isFromProductPage) {
		const newHandle = productHandle.replace('256gb', '512gb');
		window.location.href = `/products/${newHandle}`;
	  }
	}
  });*/
  
   const now = new Date();
	const ukTime = new Intl.DateTimeFormat("en-GB", {
	  timeZone: "Europe/London",
	  hour: "2-digit",
	  minute: "2-digit",
	  hour12: false
	}).formatToParts(now);
	const hours = parseInt(ukTime.find(part => part.type === "hour").value, 10);
	if (hours >= 12 && hours <= 23) {
	  const el = document.querySelector('.urgency-mechanism');
	  if (el) {
		el.style.display = 'none';
	  }
	}

function addVariantIdToCart(id, callback) {
	fetch("/cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json"
		},
		body: JSON.stringify({
			items: [{
				id: id,
				quantity: 1
			}]			
		})
	}).then(response => {
		if (!response.ok) throw new Error("Network response was not ok");
		return response.json()
	}).then(data2 => {
		refreshCartCount();
		if(callback) {
			callback();
		}
	});
}

function getFeeVariantId(price) {
	let index = 2;
	if(price < 40000) {
		index = 0;
	} else if(price < 60000) {
		index = 1;
	}

	return window.theme.techCheckVariants[index];
}

if(window.theme.pdpHideOosTest) {
	document.addEventListener('DOMContentLoaded', hideFullyOOSOptions);
	document.addEventListener("variant:changed", hideFullyOOSOptions);
}

function hideFullyOOSOptions() {
  const productDataEl = document.querySelector('[data-product-json]');  
  if (!productDataEl) return;

  const product = JSON.parse(productDataEl.textContent).product;
  if (!product) return;

  // If fully out of stock, don't hide anything
  const hasAnyStock = product.variants.some(v => v.available);
  document.querySelector('.product-info-wrapper')?.classList.toggle('product-fully-oos', !hasAnyStock);
  if (!hasAnyStock) {
	return;
  }

  // Find which option index is "condition"
  const conditionOptionIndex = product.options
    .findIndex(o => o.toLowerCase().includes('condition'));
  if (conditionOptionIndex === -1) return;

  const optionKey = `option${conditionOptionIndex + 1}`; // e.g. "option2"

  // Group variants by condition value, check if any colour is available
  const conditionAvailability = {};
  product.variants.forEach(v => {
    const condition = v[optionKey];
    if (!conditionAvailability[condition]) conditionAvailability[condition] = false;
    if (v.available) conditionAvailability[condition] = true;
  });

  // Hide condition swatches where no stock exists for any colour
  document.querySelectorAll('.condition-my-condition .block-swatch').forEach(swatch => {
    const label = swatch.querySelector('.block-swatch__item')?.value
      || swatch.querySelector('input')?.value;
    if (label && conditionAvailability[label] === false) {
      swatch.style.display = 'none';
    }
  });

  // Hide colour swatches where no stock exists for any condition
  const colourOptionIndex = product.options
    .findIndex(o => o.toLowerCase().includes('colour') || o.toLowerCase().includes('color'));
  if (colourOptionIndex === -1) return;

  const colourKey = `option${colourOptionIndex + 1}`;

  const colourAvailability = {};
  product.variants.forEach(v => {
    const colour = v[colourKey];
    if (!colourAvailability[colour]) colourAvailability[colour] = false;
    if (v.available) colourAvailability[colour] = true;
  });

  document.querySelectorAll('.color-swatch-list .color-swatch').forEach(swatch => {
    const label = swatch.querySelector('input')?.value;
    if (label && colourAvailability[label] === false) {
      swatch.style.display = 'none';
    }
  });
}

// ---------------------------------------------------------------------------
// REB-244: Battery option behaviour (price + visibility). Scoped to the Battery
// option only via the .battery-swatch-group hook; the Condition / Colour /
// Storage selectors and all shared/core logic are left untouched.
//
//  Bug A — chip price: the shared block-swatch resolver renders a representative
//    "from" Standard price. For Battery the chip must show the price of the
//    variant matching the FULL current selection (Colour + Condition + Battery).
//
//  Bug B — visibility: the theme's core ProductVariants component (theme.js), on
//    every variant change, hides ALL .block-swatch__item-second-swatch elements
//    and then only re-shows them by matching data-title === variant.option2
//    (the Condition value). Battery swatches (data-title "Standard Battery" /
//    "New Battery") never match a Condition value, so once hidden they are never
//    restored. We re-assert the battery group's correct state after that runs:
//      - the whole Battery section is shown whenever this product offers a New
//        Battery option at all;
//      - BOTH battery rows (Standard + New) are always shown while the section
//        is active — we never hide an individual row, so the currently-selected
//        battery can never disappear. The core component already greys out a
//        value that is sold out for the current Colour + Condition + Storage
//        (block-swatch--disabled + "Sold out"), exactly like the Condition row.
// ---------------------------------------------------------------------------
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var batteryGroup = document.querySelector(".battery-swatch-group");
    if (!batteryGroup) return;

    var productDataEl = document.querySelector("[data-product-json]");
    if (!productDataEl) return;

    var product;
    try {
      product = JSON.parse(productDataEl.textContent).product;
    } catch (e) {
      return;
    }
    if (!product || !product.options || !product.variants) return;

    function positionFor(re) {
      var idx = product.options.findIndex(function (o) {
        return re.test(o);
      });
      return idx === -1 ? null : idx + 1;
    }

    var batteryPos = positionFor(/battery/i);
    if (!batteryPos) return;

    function selectedValueAt(position) {
      if (!position) return null;
      var checked = document.querySelector(
        '.product-form__single-selector[data-option-position="' +
          position +
          '"]:checked'
      );
      return checked ? checked.value : null;
    }

    function variantFor(batteryValue) {
      // Match the battery value against the FULL current selection: every
      // non-battery option (Colour, Condition, Storage, and any future option)
      // must equal its currently-selected value. Resolving on only a subset
      // (e.g. ignoring Storage) matches an arbitrary-storage variant, so stock
      // and price can resolve against the wrong variant on multi-storage
      // devices and wrongly hide the Standard row.
      return product.variants.find(function (v) {
        for (var pos = 1; pos <= product.options.length; pos++) {
          if (pos === batteryPos) {
            if (v["option" + pos] !== batteryValue) return false;
          } else {
            var selected = selectedValueAt(pos);
            if (selected != null && v["option" + pos] !== selected) return false;
          }
        }
        return true;
      });
    }

    function applyBatteryState() {
      var rows = [];
      batteryGroup.querySelectorAll(".block-swatch").forEach(function (swatch) {
        var input = swatch.querySelector("input");
        if (!input) return;
        var value = input.value;
        rows.push({
          swatch: swatch,
          value: value,
          match: variantFor(value),
          isBase: /standard/i.test(value),
        });
      });

      // Show the Battery section whenever this product offers a New Battery as
      // an option at all. Within an active section BOTH lozenges (Standard +
      // New) are always presented; the core component greys out whichever is
      // sold out for the current Colour + Condition + Storage, exactly like the
      // Condition row — so the selected battery never disappears.
      var hasNewOption = rows.some(function (r) {
        return r.value && !r.isBase;
      });
      var sectionDesired = hasNewOption ? "" : "none";

      rows.forEach(function (r) {
        // Bug A — price for the full current selection. Only override when the
        // matched variant is in stock; for a sold-out value the core component
        // writes "Sold out" into this slot, which we must not clobber.
        var priceEl = r.swatch.querySelector(".block-swatch__item-text");
        if (priceEl && r.match && r.match.available) {
          var price = Shopify.formatMoney(r.match.price, "£{{amount}}").replace(
            ".00",
            ""
          );
          if (priceEl.textContent !== price) priceEl.textContent = price;
        }

        // Re-assert visibility: the core component hides all second-swatches on
        // every variant change. Keep every battery row shown while the section
        // is active (never hide an individual row).
        if (r.swatch.style.display !== sectionDesired) {
          r.swatch.style.display = sectionDesired;
        }
      });

      // Show / suppress the whole Battery section — group AND the "Battery /
      // What's this?" heading above it — together, so no orphaned heading is
      // ever left behind.
      if (batteryGroup.style.display !== sectionDesired) {
        batteryGroup.style.display = sectionDesired;
      }
      var heading = batteryGroup.previousElementSibling;
      if (
        heading &&
        heading.classList.contains("condition-span") &&
        heading.style.display !== sectionDesired
      ) {
        heading.style.display = sectionDesired;
      }
    }

    applyBatteryState();
    document.addEventListener("variant:changed", applyBatteryState);

    // The core component re-hides battery swatches after our handler on some
    // change paths. Re-assert (guarded against re-setting an already-correct
    // value, so it converges and never loops) whenever it mutates their style.
    var observer = new MutationObserver(applyBatteryState);
    batteryGroup.querySelectorAll(".block-swatch").forEach(function (swatch) {
      observer.observe(swatch, { attributes: true, attributeFilter: ["style"] });
    });
  });
})();

// ---------------------------------------------------------------------------
// REB-244 (sibling): Condition-swatch price correction.
//   Symptom: on a product that offers a New Battery option, switching Battery
//   (or any variant change) makes EVERY Condition swatch show the same price —
//   the flat "New Battery" placeholder (e.g. all read £457.79) — even while
//   Standard Battery is selected and each condition really costs less.
//
//   Cause: the core ProductVariants component (theme.js _updateProductPrices)
//   rebuilds the Condition prices by looping over every variant whose Colour
//   (option1) matches the selection and writing that variant's price into the
//   swatch keyed on its Condition (option2). It filters on Colour ONLY — never
//   Battery — so for each Condition BOTH battery variants are visited and the
//   one that appears LAST in product.variants wins. New Battery rows sit after
//   the Standard rows, so their price clobbers every Condition swatch.
//
//   Fix: after the core runs (on variant:changed), re-assert each Condition
//   swatch's price from the variant matching the FULL current selection
//   (Colour + Battery + any other option) with only the Condition varied — the
//   exact analogue of the Battery-swatch corrector above. Scoped to products
//   that actually expose a Battery option, since that is the only dimension
//   that duplicates a Colour+Condition pair into two priced variants.
// ---------------------------------------------------------------------------
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var conditionGroup = document.querySelector(
      ".condition-my-condition:not(.battery-swatch-group)"
    );
    if (!conditionGroup) return;

    var productDataEl = document.querySelector("[data-product-json]");
    if (!productDataEl) return;

    var product;
    try {
      product = JSON.parse(productDataEl.textContent).product;
    } catch (e) {
      return;
    }
    if (!product || !product.options || !product.variants) return;

    function positionFor(re) {
      var idx = product.options.findIndex(function (o) {
        return re.test(o);
      });
      return idx === -1 ? null : idx + 1;
    }

    var conditionPos = positionFor(/condition|grade/i);
    var batteryPos = positionFor(/battery/i);
    // Without a Battery option there is only one variant per Colour+Condition,
    // so the core already resolves the correct price — nothing to fix.
    if (!conditionPos || !batteryPos) return;

    function selectedValueAt(position) {
      if (!position) return null;
      var checked = document.querySelector(
        '.product-form__single-selector[data-option-position="' +
          position +
          '"]:checked'
      );
      return checked ? checked.value : null;
    }

    // Variant matching the current selection for every option EXCEPT Condition,
    // with Condition forced to the swatch's own value.
    function variantForCondition(conditionValue) {
      return product.variants.find(function (v) {
        for (var pos = 1; pos <= product.options.length; pos++) {
          if (pos === conditionPos) {
            if (v["option" + pos] !== conditionValue) return false;
          } else {
            var selected = selectedValueAt(pos);
            if (selected != null && v["option" + pos] !== selected)
              return false;
          }
        }
        return true;
      });
    }

    function applyConditionPrices() {
      conditionGroup
        .querySelectorAll(".block-swatch")
        .forEach(function (swatch) {
          var input = swatch.querySelector("input");
          if (!input) return;
          var match = variantForCondition(input.value);
          if (!match) return;
          var priceEl = swatch.querySelector(".block-swatch__item-text");
          if (!priceEl) return;
          var price = Shopify.formatMoney(match.price, "£{{amount}}").replace(
            ".00",
            ""
          );
          if (priceEl.textContent !== price) priceEl.textContent = price;
        });
    }

    applyConditionPrices();
    document.addEventListener("variant:changed", applyConditionPrices);
  });
})();

// ---------------------------------------------------------------------------
// REB-243: dynamic battery-health pillar in the Reboxed Promise grid.
//   - default            -> "Min. 80% battery"
//   - Pristine condition -> "Min. 90% battery"  (Pristine is min 90%, per grading)
//   - New Battery variant -> "100% battery"     (brand new; overrides condition)
// Reads the currently-checked Condition / Battery swatches from the DOM. The
// Battery group also carries .condition-my-condition, so we exclude it when
// reading the Condition selection.
// ---------------------------------------------------------------------------
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var el = document.querySelector("[data-battery-health]");
    if (!el) return;

    function update() {
      var batteryInput = document.querySelector(
        ".battery-swatch-group input:checked"
      );
      var conditionInput = document.querySelector(
        ".condition-my-condition:not(.battery-swatch-group) input:checked"
      );

      var isNewBattery =
        batteryInput && !/standard/i.test(batteryInput.value);
      var isPristine =
        conditionInput && /pristine/i.test(conditionInput.value);

      var pct = isNewBattery ? 100 : isPristine ? 90 : 80;
      var text = isNewBattery ? "100% battery" : "Min. " + pct + "% battery";

      if (el.textContent !== text) el.textContent = text;

      // Fill the battery icon to match (inner track runs x=4..18, width 14 =
      // full). Kept deliberately high and non-linear so even 80% reads as a
      // mostly-full battery — an 80%-health cell is still a near-full battery.
      var fill = document.querySelector("[data-battery-fill]");
      if (fill) {
        var w = pct >= 100 ? "14" : pct >= 90 ? "13.5" : "13";
        if (fill.getAttribute("width") !== w) fill.setAttribute("width", w);
      }
    }

    update();
    document.addEventListener("variant:changed", update);
    document.addEventListener("change", function (e) {
      if (e.target.closest && e.target.closest(".condition-my-condition")) {
        update();
      }
    });
  });
})();